import { cn } from "@/lib/utils";
import { useState, useEffect } from "react";

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

// Fallback animated background using CSS
const FallbackBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Animated orbs with Raycast-inspired colors */}
      <div className="absolute -top-40 -left-40 w-80 h-80 bg-gradient-to-r from-red-500 to-orange-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
      <div className="absolute -bottom-8 left-20 w-80 h-80 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
    </div>
  );
};

export const Component = () => {
  const { width, height } = useWindowSize();
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Try to dynamically import UnicornScene
  useEffect(() => {
    const loadUnicornScene = async () => {
      try {
        await import('unicornstudio-react');
        setIsLoading(false);
      } catch (error) {
        console.warn('UnicornScene failed to load, using fallback background');
        setHasError(true);
        setIsLoading(false);
      }
    };

    loadUnicornScene();
  }, []);

  // If there's an error or still loading, show fallback
  if (hasError || isLoading) {
    return <FallbackBackground />;
  }

  // Try to render UnicornScene with error boundary
  try {
    const UnicornScene = require('unicornstudio-react').default;
    return (
      <div className={cn("absolute inset-0")}>
        <UnicornScene
          production={true}
          projectId="MiiqZiDaKUOWbdlhlARE"
          width={width}
          height={height}
          onError={() => setHasError(true)}
        />
      </div>
    );
  } catch (error) {
    console.warn('UnicornScene render failed, using fallback');
    return <FallbackBackground />;
  }
};

